
var sliderLess = {};
import genaration from '../../utils/classname';
export var sliderClass = genaration(sliderLess, 'slider');